import IconQilu from '@/images/h5-common/logo.webp';
import IconHanzi from '@/images/hanzi/logo_hanzi.webp';
import React from 'react';
import {
  handleDownloadAndroidApp,
  handleDownloadIOSApp,
} from '@/utils/DownloadUtils';
import { isWechat } from '@/utils/wechat_utils';

// 定义Props接口
interface DownloadAppBannerProps {
  alignBottom?: boolean;
  maxWidthClassName?: string;
  outerPaddingClassName?: string;
  appName?: 'hanzi';
  onWechatDownload?: () => void;
}

const DEFAULT_CONFIG = {
  logo: IconQilu,
  title: '天才鸭',
  subtitle: '英语学习好帮手',
  buttonClassName: 'bg-[#FFAA1B]',
};

const HANZI_CONFIG = {
  logo: IconHanzi,
  title: '天才鸭汉字',
  subtitle: '一站式专业语文识字学习平台',
  buttonClassName: 'bg-[#5264FF]',
};

function DowloadAppBanner({
  alignBottom = true,
  maxWidthClassName = 'max-w-[800px]',
  outerPaddingClassName = '',
  appName,
  onWechatDownload,
}: DownloadAppBannerProps) {
  const config = appName === 'hanzi' ? HANZI_CONFIG : DEFAULT_CONFIG;

  const handleDownload = () => {
    if (isWechat()) {
      onWechatDownload?.();
      return;
    }
    if (appName === 'hanzi') {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      if (isIOS) {
        handleDownloadIOSApp('hanzi');
      } else {
        handleDownloadAndroidApp('hanzi');
      }
      return;
    }
    window.location.href = 'https://sduck.net';
  };

  return (
    <div className='fixed top-0 bottom-0 right-0 left-0 pointer-events-none z-[1000]'>
      <div className='relative w-full h-full'>
        <div className={`absolute ${alignBottom?'bottom-0 ':'top-0'} left-0 right-0 pointer-events-auto`}>
          <div className={`flex w-full justify-center bg-white ${outerPaddingClassName}`.trim()}>
            <div className={`flex flex-row h-[80px] w-full ${maxWidthClassName} items-center justify-between pl-[16px] pr-[16px]`.trim()}>
              <div className='flex flex-row items-center'>
                <img src={config.logo} alt='' className='w-[55px] h-[55px] rounded-[12px]'/>
                <div className='flex flex-col ml-[10px]'>
                  <div className='text-[#313131] text-[14px] font-semibold whitespace-nowrap mb-[3px]'>
                    {config.title}
                  </div>
                  <div className='text-[#666666] text-[13px] font-normal whitespace-nowrap'>
                    {config.subtitle}
                  </div>
                </div>
              </div>
              <div
                  onClick={handleDownload}
                  className={`w-[80px] h-[35px] rounded-full ${config.buttonClassName} flex items-center justify-center text-[#FFFFFF]`}>
                下载App
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DowloadAppBanner;
